import { isRecord } from '@kuow/core';

// SDK errors sometimes put the REST response in the message instead of a body.
// Keep only error codes/correlation IDs, never the full response or headers.
function errorBody(value: unknown): Record<string, unknown> {
  if (isRecord(value)) return value;
  if (typeof value !== 'string') return {};
  const start = value.indexOf('{');
  if (start < 0) return {};
  try {
    const parsed: unknown = JSON.parse(value.slice(start));
    return isRecord(parsed) ? parsed : {};
  } catch { return {}; }
}

function diagnosticCode(value: unknown): string | undefined {
  return typeof value === 'string' && /^[a-z0-9_.:-]{1,100}$/i.test(value) ? value : undefined;
}

export function paypalErrorDiagnostic(error: unknown) {
  const record = isRecord(error) ? error : {};
  const response = isRecord(record.response) ? record.response : {};
  const rawMessage = typeof record.message === 'string' ? record.message : typeof error === 'string' ? error : '';
  const directBody = record.debug_id || Array.isArray(record.details) || record.error ? record : {};
  const body = errorBody(response.body ?? response.data ?? record.body
    ?? (typeof record.response === 'string' ? record.response : undefined)
    ?? (rawMessage.includes('{') ? rawMessage : directBody));
  const rawStatus = response.status ?? record.status ?? record.statusCode
    ?? /status(?:\s+code)?[\s:=]+(\d{3})/i.exec(rawMessage)?.[1];
  const status = typeof rawStatus === 'number' || typeof rawStatus === 'string' ? Number(rawStatus) : NaN;
  const message = rawMessage.split(/[\r\n{]/, 1)[0]
    .replace(/https?:\/\/[^\s]+/gi, '[URL]')
    .replace(/\b(?:Bearer|Basic)\s+[^\s,;]+/gi, '[credential]')
    .replace(/\b(?:access_token|authorization|client_secret|token|password)\s*[:=]\s*[^\s,;]+/gi, '[credential]')
    .replace(/[^\s@]+@[^\s@]+/g, '[email]')
    .slice(0, 300);
  return {
    name: diagnosticCode(record.name), message,
    code: diagnosticCode(record.code),
    status: Number.isInteger(status) && status >= 100 && status <= 599 ? status : undefined,
    paypalName: diagnosticCode(body.name ?? body.error),
    debugId: diagnosticCode(body.debug_id ?? /(?:correlation|debug)[-_\s]*id\s*[:=]\s*([a-z0-9-]+)/i.exec(rawMessage)?.[1]),
    issues: Array.isArray(body.details) ? body.details.flatMap(detail => {
      const issue = isRecord(detail) ? diagnosticCode(detail.issue) : undefined;
      return issue ? [issue] : [];
    }).slice(0, 10) : [],
  };
}
